import React from 'react'
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'

import TableFilter from '../../components/TableFilter'
import TableSorting from '../../components/TableSorting'

const LocalTranslationTableFilter = ({
  filterColumn = null,
  filterOnEmptyOnly = false,
  filterQuery = null,
  onColumnChange,
  onEmptyOnlyClick,
  onQueryChange,
  onSortChange,
  onSubmit = () => {},
  sortingOption = null
}) => {
  const { t } = useTranslation('TranslationsPage')

  return (
    <Row>
      <Col
        className="mb-3 mb-md-0"
        md="8"
      >
        <Card color="light">
          <CardBody>
            <CardTitle tag="h5">
              {t('LocalTranslationTableFilter.filterTitle')}
            </CardTitle>

            <TableFilter
              filterColumn={filterColumn}
              filterQuery={filterQuery}
              onColumnChange={onColumnChange}
              onQueryChange={onQueryChange}
              onSubmit={onSubmit}
            />

            <FormGroup switch className="z-0">
              <Input
                checked={filterOnEmptyOnly}
                id="empty-strings-only-btn"
                name="customSwitch"
                onChange={({ target: { checked } }) => onEmptyOnlyClick(checked)}
                type="switch"
              />
              <Label check for="empty-strings-only-btn">
                {t('LocalTranslationTableFilter.emptyOnlyButton')}
              </Label>
            </FormGroup>
          </CardBody>
        </Card>
      </Col>

      <Col md="4">
        <Card
          className="h-100"
          color="light"
        >
          <CardBody>
            <CardTitle tag="h5">
              {t('LocalTranslationTableFilter.sortTitle')}
            </CardTitle>

            <TableSorting
              sortingOption={sortingOption}
              onSortChange={onSortChange}
              onSubmit={onSubmit}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

LocalTranslationTableFilter.propTypes = {
  filterColumn: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }),
  filterOnEmptyOnly: PropTypes.bool,
  filterQuery: PropTypes.string,
  onColumnChange: PropTypes.func.isRequired,
  onEmptyOnlyClick: PropTypes.func.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  sortingOption: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })
}

export default LocalTranslationTableFilter
